import { z } from "zod";
export const dashboardBindingReview = z
    .object({
    provenance: z
        .object({
        wiring: z.string().min(1),
        devices: z.string().min(1),
        catalog: z.string().nullable(),
    })
        .strict(),
    /** Canonical binding descriptions computed by the server at review/save time. */
    blocks: z.record(z.string().min(1), z.string().min(1)),
})
    .strict();
//# sourceMappingURL=fermentation-dashboard-binding-review.js.map